import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.851 4.167c0-.369.298-.667.667-.667h9.333c.368 0 .667.298.667.667v2a.667.667 0 0 1-.667.666H3.518a.667.667 0 0 1-.667-.666zm1.333.666V5.5h8v-.667z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.419 5.507a.667.667 0 0 1 .758.56l.915 7.1h4.185l.915-7.1a.667.667 0 1 1 1.318.199l-1 7.666a.67.67 0 0 1-.659.568H5.518a.67.67 0 0 1-.66-.568l-1-7.666a.667.667 0 0 1 .56-.759M5.518 2.833a.667.667 0 0 0-.667.667v.667a.667.667 0 1 1-1.333 0V3.5a2 2 0 0 1 2-2h5.333a2 2 0 0 1 2 2v.667a.667.667 0 0 1-1.333 0V3.5a.667.667 0 0 0-.667-.667z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })